export enum ProfileChangeStatus {
  FUTURE = 'FU',
  PENDING = 'PN',
  NONE = 'NO'
}
